<div
  class="tooltip"
  role="tooltip"
  [ngClass]="['tooltip--' + position]"
  [class.tooltip--visible]="visible"
  [style.left]="left + 'px'"
  tabindex="0"
  [attr.aria-label]="sedsTooltip"
  [style.top]="top + 'px'">
  {{ sedsTooltip }}
</div>
